import { Component, OnInit } from '@angular/core';
import { ASC } from '@app/core/constants/Constants';
import { Filter } from '@app/core/models/front/filters';
import { Sorters } from '@app/core/models/front/sorters';
import { SignedDocumentsByCompany } from '@app/core/models/input/statistics/documents-generated.model';
import { StatisticsService } from '@app/core/services/statistics/statistics.service';
import { FilterUtils } from '@app/core/utils/filter.utils';
import { SorterUtils } from '@app/core/utils/sorter.utils';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-total-signs-by-company',
  templateUrl: './total-signs-by-company.component.html',
  styleUrls: ['./total-signs-by-company.component.scss'],
})
export class TotalSignsByCompanyComponent implements OnInit {
  filters = new Array<Filter>();
  sorter = new Sorters('businessName', ASC);
  signatures?: SignedDocumentsByCompany;

  // Utils
  filterUtils: FilterUtils;
  sorterUtils: SorterUtils;

  nameFilter = new Filter();
  nameFilterStr?: string;
  isCheckedExcludeBio = false;

   faCaretDown = faCaretDown;
   faCaretUp = faCaretUp;

  constructor(private readonly statisticsService: StatisticsService) {
    this.filterUtils = new FilterUtils(this.filters);
     this.sorterUtils = new SorterUtils(this.sorter);
  }

  ngOnInit(): void {
    this.getSignaturesByCompany();
  }

  addFilter(name: string, filter: string) {   
    this.filterUtils.addFilter(name, filter);
    this.getSignaturesByCompany();
  }

   removeFilter(name: string) {      
    this.filterUtils.removeFilter(name);
     this.getSignaturesByCompany();
  }

   sortSignatures(property: string, direction: string) {
    this.sorterUtils.sortData(property, direction);
    this.getSignaturesByCompany();
}

  getSignaturesByCompany() {
    this.statisticsService.getSignaturesByCompany(this.filters, this.sorter).subscribe({
      next: respuesta => {
        this.signatures = respuesta;               
      },
    });
  }

   checkedExcludeBio() {   
    this.isCheckedExcludeBio = !this.isCheckedExcludeBio;
    if(this.isCheckedExcludeBio){
      this.addFilter('excludeBio', 'true');
    } else {
      this.removeFilter('excludeBio');
    }
    
  }
}
